import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './identitiesActions';
import * as transformers from './identitiesTransformers';

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'identities',
    resourceBaseUrl: '/identities',

    transformResourceToRequestData: transformers.transformIdentityToRequestData,
    transformResourceWithResponse: transformers.transformIdentityResponseWithResource,

    successAction,
    failureAction,
  });

function* getIdentitiesActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getIdentitiesSuccess, actions.getIdentitiesFailure);
  yield takeEvery(actions.getIdentities, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

function* createIdentityActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createIdentitySuccess, actions.createIdentityFailure);
  yield takeEvery(actions.createIdentity, resourceSagaUtils.qcsSyncCreateResource, resourceConfig);
}

function* updateIdentityActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateIdentitySuccess, actions.updateIdentityFailure);
  yield takeEvery(actions.updateIdentity, resourceSagaUtils.qcsSyncUpdateResource, resourceConfig);
}

function* deleteIdentityActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteIdentitySuccess, actions.deleteIdentityFailure);
  yield takeEvery(actions.deleteIdentity, resourceSagaUtils.qcsSyncDeleteResource, resourceConfig);
}

export default [
  getIdentitiesActionWatcher,
  createIdentityActionWatcher,
  updateIdentityActionWatcher,
  deleteIdentityActionWatcher,
];
